import { useSystemFeatureFlagIsActive } from 'utils/systemUtils'
import { useSnapshot } from 'valtio'
import { dayAheadBidModeStore, setDayAheadBidMode } from '../../store/dayAheadBidModeStore'
import { isSingleDayAheadBidDay } from './DayAheadBidTable.grid.helper'

export type { DayAheadBidEditorMode } from '../../store/dayAheadBidModeStore'

type UseDayAheadBidTableModeInput = {
  startTime: ISODateTime
  endTime: ISODateTime
  requireTagForBlockBids: boolean
}

type UseDayAheadBidTableModeResult = {
  isModeSwitchVisible: boolean
  activeMode: 'table' | 'modal'
  setMode: (mode: 'table' | 'modal') => void
}

export function useDayAheadBidTableMode({
  startTime,
  endTime,
  requireTagForBlockBids,
}: UseDayAheadBidTableModeInput): UseDayAheadBidTableModeResult {
  const isFlagActive = useSystemFeatureFlagIsActive('use_day_ahead_bid_table')
  const { mode } = useSnapshot(dayAheadBidModeStore)

  const isTableModeAvailable = isFlagActive && requireTagForBlockBids && isSingleDayAheadBidDay(startTime, endTime)

  return {
    isModeSwitchVisible: isTableModeAvailable,
    activeMode: isTableModeAvailable ? mode : 'modal',
    setMode: setDayAheadBidMode,
  }
}
